const POLL_INTERVAL = 30
const MAX_ATTEMPTS = 500

interface PollUntilTrueParams {
  pollFunction: () => Promise<boolean> | boolean
  interval?: number
  maxAttempts?: number
  errorMessage: string
}

export async function pollUntilTrue({
  pollFunction,
  interval = POLL_INTERVAL,
  maxAttempts = MAX_ATTEMPTS,
  errorMessage,
}: PollUntilTrueParams): Promise<boolean> {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const conditionMet = await pollFunction()

      if (conditionMet) {
        return true
      }
    } catch (error) {
      throw new Error(errorMessage)
    }

    await new Promise((resolve) => setTimeout(resolve, interval))
  }
  throw new Error(errorMessage)
}
